///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Route } from '@angular/router';

import { SettingsComponent } from './settings.component';
import { UserAuthorities } from '../../services/user/user-authorities';
import { canActivateUser } from '../../shared/auth/user-route-access-service';

export const settingsRoute: Route = {
    path: 'settings',
    component: SettingsComponent,
    data: {
        authorities: UserAuthorities.ALL,
        pageTitle: 'global.menu.account.settings'
    },
    canActivate: [canActivateUser],
    title: 'Settings'
};
